import { render } from "./ApexBarChart.vue?vue&type=template&id=911345a6"
import script from "./ApexBarChart.vue?vue&type=script&lang=js"
export * from "./ApexBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__